module.exports = __webpack_public_path__ + "img/prize-02-pic.0738d9cd.png";